export default "__VITE_ASSET__1oV7xAXKZMql0H3IJxU8wQ__";